// " /api/buildings/5/reports/assets_borrowed_detail"
import axios from 'axios';
import { BACKEND_CLOUD } from '../consts/backend';
import * as Auth from '../helpers/Auth';

export const getDataDashThree = (buildindId, membershipId) =>
  new Promise((resolve, reject) => {
    const token = Auth.getToken();
    const TIMEZONE_OFFSET = new Date().getTimezoneOffset();

    axios
      .get(
        `${BACKEND_CLOUD}/api/buildings/${buildindId}/reports/assets_borrowed_detail`,
        {
          headers: {
            'Access-Control-Allow-Origin': true,
            Authorization: `User ${token}`,
            'x-alliotcloud-membershipid': membershipId,
            'X-Client-TimezoneOffset': TIMEZONE_OFFSET,
          },
        }
      )
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });
